<template>
  <div class="calendar-container">
    <v-card class="calendar-controls elevation-2 mb-6">
      <v-container fluid>
        <v-layout row wrap align-center>
          <v-flex lg3 md3 sm12 xs12>
            <v-dialog ref="dialog" persistent v-model="modal1" lazy full-width width="290px"
                      :return-value.sync="calendar.start_date">
              <v-text-field slot="activator"
                            label="Start Date"
                            v-model="calendar.start_date"
                            readonly
                            prepend-icon="event"
                            class="date-picker-input fade-control"></v-text-field>
              <v-date-picker v-model="calendar.start_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal1 = false" class="fade-btn">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.dialog.save(calendar.start_date)" class="fade-btn">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-dialog ref="dialog1" persistent v-model="modal2" lazy full-width width="290px"
                      :return-value.sync="calendar.end_date">
              <v-text-field slot="activator"
                            label="End Date"
                            v-model="calendar.end_date"
                            readonly
                            prepend-icon="event"
                            class="date-picker-input fade-control"></v-text-field>
              <v-date-picker :min="calendar.start_date" v-model="calendar.end_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal2 = false" class="fade-btn">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.dialog1.save(calendar.end_date)" class="fade-btn">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-select label="Select Calendar Item"
                      v-model="calendar.calendar_item"
                      :items="allCalendarItems"
                      required
                      item-text="value"
                      item-value="id"
                      :loading="$loadingTrue"
                      prepend-icon="list"
                      class="calendar-select fade-control"></v-select>
          </v-flex>
          <v-flex lg3 md3 sm12 xs12>
            <v-btn color="primary"
                   @click="getData()"
                   block
                   :loading="this.$store.state.LoadingStore.loading"
                   class="get-dates-btn neon-btn">
              Get Selected Dates
              <template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>cached</v-icon>
                </span>
              </template>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <!-- Full-page calendar section loader (shown only after button click while loading) -->
    <div v-if="showFullPageLoader" class="full-page-loader-overlay">
      <div class="loader-content">
        <v-progress-circular indeterminate color="#74a533" size="64"></v-progress-circular>
      </div>
    </div>

    <div class="calendar-table-container" :class="{ 'loading-active': showFullPageLoader }">
      <v-card class="elevation-2 calendar-card">
        <div class="calendar-scroll-wrapper">
          <table class="calendar-table">
            <thead class="calendar-header">
              <tr>
                <th class="header-day">DAYS</th>
                <th v-for="(date, key) in getWeek"
                    :class="{ 'weekend-day': getDay(date) }"
                    :key="key"
                    class="header-date">
                  <div class="date-display">
                    <div class="day-name">{{ formatDate(date) }}</div>
                    <div class="full-date">{{ date }}</div>
                  </div>
                </th>
              </tr>
              <tr>
                <th class="service-name header-row">
                  <div class="component-name">SERVICES</div>
                </th>
                <td v-for="(date, key) in getWeek"
                    :class="{ 'weekend-cell': getDay(date) }"
                    :key="key">
                </td>
              </tr>
            </thead>
            <tbody class="calendar-body">
              <div v-if="!showFullPageLoader &&
                   (getInventoryCalendar.length <= 0 &&
                    getAccomodationCalendar.length <= 0 &&
                    getExternalAccomodationCalendar.length <= 0 &&
                    getCampingCalendar.length <= 0)"
                   class="loading-indicator">
                <v-progress-circular indeterminate color="#74a533" size="64"></v-progress-circular>
              </div>

              <template v-if="getInventoryCalendar.length > 0">
                <tr v-for="(inventory, key) in getInventoryCalendar" :key="'inventory' + key">
                  <th class="service-name inventory-service">
                    <div class="component-name">{{ inventory.inventory_name }}</div>
                  </th>
                  <td v-for="(slot, key) in inventory.inventory_details"
                      :key="key"
                      :class="{ 'weekend-cell': getDay(slot.date) }">
                    <v-btn v-if="slot.available_slots === 0 && slot.number_of_extra_people == 0"
                           color="error"
                           small
                           @click="getInventoryDetails(inventory.inventory_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots === 0 && slot.number_of_extra_people > 0"
                           color="#F8B229"
                           small
                           @click="getInventoryDetails(inventory.inventory_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots > 0 && slot.number_of_extra_people == 0"
                           color="default"
                           small
                           @click="getInventoryDetails(inventory.inventory_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots > 0 && slot.number_of_extra_people > 0"
                           color="#F8B229"
                           small
                           @click="getInventoryDetails(inventory.inventory_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots < 0 && slot.number_of_extra_people == 0"
                           color="info"
                           small
                           @click="getInventoryDetails(inventory.inventory_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots < 0 && slot.number_of_extra_people > 0"
                           color="#F8B229"
                           small
                           @click="getInventoryDetails(inventory.inventory_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template v-if="getAccomodationCalendar.length > 0">
                <tr v-for="(accomodation, key) in getAccomodationCalendar" :key="'facility' + key">
                  <th class="service-name accomodation-service">
                    <div class="component-name">{{ accomodation.accomodation_name }}</div>
                  </th>
                  <td v-for="(slot, key) in accomodation.accomodation_details"
                      :key="key"
                      :class="{ 'weekend-cell': getDay(slot.date) }">
                    <v-btn v-if="slot.available_slots === 0 && slot.number_of_extra_people == 0"
                           color="error"
                           small
                           @click="getFacilityDetails(accomodation.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots === 0 && slot.number_of_extra_people > 0"
                           color="#F8B229"
                           small
                           @click="getFacilityDetails(accomodation.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots > 0 && slot.number_of_extra_people == 0"
                           color="default"
                           small
                           @click="getFacilityDetails(accomodation.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots > 0 && slot.number_of_extra_people > 0"
                           color="#F8B229"
                           small
                           @click="getFacilityDetails(accomodation.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots < 0 && slot.number_of_extra_people == 0"
                           color="info"
                           small
                           @click="getFacilityDetails(accomodation.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots < 0 && slot.number_of_extra_people > 0"
                           color="#F8B229"
                           small
                           @click="getFacilityDetails(accomodation.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template v-if="getExternalAccomodationCalendar.length > 0">
                <tr v-for="(external_accomodation, key) in getExternalAccomodationCalendar" :key="'facility' + key">
                  <th class="service-name external-service">
                    <div class="component-name">{{ external_accomodation.accomodation_name }}</div>
                  </th>
                  <td v-for="(slot, key) in external_accomodation.external_accomodation_details"
                      :key="key"
                      :class="{ 'weekend-cell': getDay(slot.date) }">
                    <v-btn v-if="slot.available_slots === 0 && slot.number_of_extra_people == 0"
                           color="error"
                           small
                           @click="getFacilityDetails(external_accomodation.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots === 0 && slot.number_of_extra_people > 0"
                           color="#F8B229"
                           small
                           @click="getFacilityDetails(external_accomodation.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots > 0 && slot.number_of_extra_people == 0"
                           color="default"
                           small
                           @click="getFacilityDetails(external_accomodation.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots > 0 && slot.number_of_extra_people > 0"
                           color="#F8B229"
                           small
                           @click="getFacilityDetails(external_accomodation.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots < 0 && slot.number_of_extra_people == 0"
                           color="info"
                           small
                           @click="getFacilityDetails(external_accomodation.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots < 0 && slot.number_of_extra_people > 0"
                           color="#F8B229"
                           small
                           @click="getFacilityDetails(external_accomodation.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                  </td>
                </tr>
              </template>
              <template v-if="getCampingCalendar.length > 0">
                <tr v-for="(camping, key) in getCampingCalendar" :key="'camp' + key">
                  <th class="service-name camping-service">
                    <div class="component-name">{{ camping.accomodation_name }}</div>
                  </th>
                  <td v-for="(slot, key) in camping.accomodation_details"
                      :key="key"
                      :class="{ 'weekend-cell': getDay(slot.date) }">
                    <v-btn v-if="slot.available_slots === 0 && slot.number_of_extra_people == 0"
                           color="error"
                           small
                           @click="getFacilityDetails(camping.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots === 0 && slot.number_of_extra_people > 0"
                           color="#F8B229"
                           small
                           @click="getFacilityDetails(camping.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots > 0 && slot.number_of_extra_people == 0"
                           color="default"
                           small
                           @click="getFacilityDetails(camping.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots > 0 && slot.number_of_extra_people > 0"
                           color="#F8B229"
                           small
                           @click="getFacilityDetails(camping.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots < 0 && slot.number_of_extra_people == 0"
                           color="info"
                           small
                           @click="getFacilityDetails(camping.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                    <v-btn v-if="slot.available_slots < 0 && slot.number_of_extra_people > 0"
                           color="#F8B229"
                           small
                           @click="getFacilityDetails(camping.accomodation_id, slot.date)"
                           class="slot-btn fade-btn">
                      {{ slot.available_slots }}
                    </v-btn>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </v-card>
    </div>
    <v-bottom-sheet v-model="sheet" class="bookings-sheet">
      <v-card>
        <v-card-title class="sheet-header">
          BOOKINGS
          <v-spacer></v-spacer>
          <v-btn icon @click="sheet = false" class="fade-btn">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="max-height: 400px; overflow-y: auto;">
          <bookings></bookings>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>
<script>
  import Bookings from "./Bookings/Bookings";
  import HotelDatePicker from "vue-hotel-datepicker";
  export default {
    name: "Calendar",
    components: {
      Bookings,
      HotelDatePicker,
    },
    data() {
      return {
        menu1: false,
        modal1: false,
        menu2: false,
        modal2: false,
        alert: false,
        date_settings: {
          night: "Day",
          nights: "Days",
          "day-names": ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"],
          "check-in": "Start-Date",
          "check-out": "End-Date",
          "month-names": [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
        },
        today: this.$moment.now(),
        calendar: {
          start_date: this.$moment(this.today).format("YYYY-MM-DD"),
          end_date: this.$moment(this.today).add(4, "days").format("YYYY-MM-DD"),
          calendar_item: "2",
        },
        sheet: false,
        showFullPageLoader: false, // Controls full-page loader visibility
      };
    },
    created() {
      this.$store.dispatch("get_calendar_facility", this.calendar);
    },
    methods: {
      getFacilityDetails(facility, date) {
        this.sheet = true;
        var data = {
          facility_id: facility,
          date: this.$moment(date).format("YYYY-MM-DD"),
        };
        this.$store.dispatch("get_calendar_facility_bookings", data);
      },
      getInventoryDetails(inventory, date) {
        this.sheet = true;
        var data = {
          inventory_id: inventory,
          date: this.$moment(date).format("YYYY-MM-DD"),
        };
        this.$store.dispatch("get_calendar_inventory_bookings", data);
      },
      formatDate(date) {
        return this.$moment(date).format("ddd").toUpperCase();
      },
      getDay(day) {
        var date = this.$moment(day).weekday();
        return (date === 6) || (date === 0);
      },
      getData() {
        // Show full-page loader only when button is clicked and loading starts
        this.showFullPageLoader = true;
        this.$store.dispatch("loading_true");
        let item = this.calendar.calendar_item;
        if (item == "2") {
          this.$store.dispatch("get_calendar_facility", this.calendar);
        } else if (item == "3") {
          this.$store.dispatch("get_calendar_external_facility", this.calendar);
        } else if (item == "4") {
          this.$store.dispatch("get_camping_sites_facility", this.calendar);
        } else {
          this.$store.dispatch("get_calendar_inventory", this.calendar);
        }
      },
      next7() {
        var start = this.$moment(this.today).add(7, "days").format("YYYY-MM-DD");
        this.calendar.start_date = start;
        this.calendar.end_date = this.$moment(start)
          .add(7, "days")
          .format("YYYY-MM-DD");
        this.today = start;
        this.$store.dispatch("get_calendar", this.calendar);
      },
      last7() {
        var start = this.$moment(this.today)
          .subtract(7, "days")
          .format("YYYY-MM-DD");
        this.calendar.start_date = start;
        this.calendar.end_date = this.$moment(start)
          .subtract(7, "days")
          .format("YYYY-MM-DD");
        this.today = start;
        this.$store.dispatch("get_calendar", this.calendar);
      },
    },
    computed: {
      isLoading() {
        return this.$store.state.LoadingStore.loading;
      },
      getWeek() {
        var start = this.calendar.start_date;
        var a = this.$moment(
          this.$moment(this.calendar.start_date).format("YYYY, MM, DD")
        );
        var b = this.$moment(
          this.$moment(this.calendar.end_date).format("YYYY, MM, DD")
        );
        var max = b.diff(a, "days");
        var days = [];
        for (var i = 0; i <= max; i++) {
          var day = this.$moment(start).add(i, "days").format("DD MMM, YYYY");
          days.push(day);
        }
        return days;
      },
      allCalendarItems() {
        let calendarItems = [
          {
            id: "2",
            value: "Facility",
          },
          {
            id: "3",
            value: "Ol pejeta Escapes",
          },
          {
            id: "4",
            value: "Camping Sites",
          },
          {
            id: "1",
            value: "Inventory",
          },
        ];
        return calendarItems;
      },
    },
    watch: {
      // Hide full-page loader when global loading state becomes false
      'isLoading'(newVal) {
        if (!newVal) {
          this.showFullPageLoader = false;
        }
      }
    }
  };
</script>
<style scoped>
  .calendar-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
    position: relative;
  }

  .calendar-controls {
    border-radius: 12px !important;
    padding: 15px;
    background: #ffffff;
    box-shadow: 0 8px 30px rgba(0,0,0,0.12) !important;
    border: 1px solid rgba(0,0,0,0.05);
  }

  .date-picker-input {
    margin-top: 8px;
  }

  .calendar-select {
    margin-top: 8px;
  }
  /* Fade effects */
  .fade-control {
    transition: all 0.5s ease;
    opacity: 0.9;
  }

    .fade-control:hover {
      opacity: 1;
      transform: translateY(-1px);
    }

  .fade-btn {
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    opacity: 0.9;
  }

    .fade-btn:hover {
      opacity: 1;
      transform: scale(1.02);
    }
  /* Enhanced button styling */
  .neon-btn {
    margin-top: 8px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 14px;
    height: 48px;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    background-color: #74a533 !important;
    position: relative;
    overflow: hidden;
    z-index: 1;
    box-shadow: 0 4px 12px rgba(116, 165, 51, 0.3);
    border: none;
    color: white;
  }

    .neon-btn::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
      transition: 0.5s;
      z-index: -1;
    }

    .neon-btn:hover::before {
      left: 100%;
    }

    .neon-btn:hover {
      box-shadow: 0 6px 16px rgba(116, 165, 51, 0.4);
      transform: translateY(-2px);
    }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }

  @keyframes loader {
    from {
      transform: rotate(0);
    }

    to {
      transform: rotate(360deg);
    }
  }

  .calendar-table-container {
    margin-top: 20px;
    overflow-x: auto;
    position: relative;
    transition: opacity 0.3s ease;
  }

    .calendar-table-container.loading-active {
      opacity: 0.3;
      pointer-events: none;
    }

  .calendar-card {
    border-radius: 12px !important;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0 8px 30px rgba(0,0,0,0.12) !important;
    border: 1px solid rgba(0,0,0,0.05);
  }

  .calendar-scroll-wrapper {
    overflow-x: auto;
    padding: 10px;
  }

  .calendar-table {
    width: 100%;
    min-width: 800px;
    border-collapse: separate;
    border-spacing: 0 4px;
  }

  .calendar-header {
    background-color: #74a533;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }

  .header-day {
    min-width: 150px;
    padding: 16px;
    font-weight: 600;
    text-align: left;
    color: white;
    font-size: 16px;
    letter-spacing: 1px;
    position: sticky;
    left: 0;
    z-index: 2;
    background-color: #74a533;
  }

  .header-date {
    min-width: 100px;
    padding: 12px 8px;
    text-align: center;
  }

  .date-display {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .day-name {
    font-weight: 600;
    font-size: 15px;
    color: lightgray;
    letter-spacing: 1px;
  }

  .full-date {
    font-size: 12px;
    color: lightgray;
    margin-top: 4px;
  }

  .calendar-body {
    background-color: transparent;
  }

  .service-name {
    padding: 12px 10px;
    font-weight: 600;
    text-align: left;
    border-radius: 4px 0 0 4px;
    font-size: 14px;
    letter-spacing: 1px;
    min-width: 150px;
    max-width: 150px;
    position: sticky;
    left: 0;
    z-index: 1;
  }

  .component-name {
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.4;
    padding: 4px 0;
    font-size: 13px;
  }

  .header-row {
    background-color: #74a533;
    color: white;
  }

  .inventory-service {
    background-color: #73a533;
    color: white;
  }

  .accomodation-service {
    background-color: #fdb813;
    color: white;
  }

  .external-service {
    background-color: #2196f3;
    color: white;
  }

  .camping-service {
    background-color: #520036;
    color: white;
  }

  .weekend-day {
    background-color: #5d8a2a;
  }

  .weekend-cell {
    background-color: #FFCDD2;
  }

  .slot-btn {
    min-width: 40px;
    margin: 2px;
    font-weight: 600;
    transition: all 0.3s ease;
    height: 32px !important;
    font-size: 13px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

    .slot-btn:hover {
      transform: scale(1.05);
      box-shadow: 0 4px 8px rgba(0,0,0,0.2);
    }

  .loading-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    width: 100%;
  }

  .bookings-sheet {
    z-index: 1000;
  }

  .sheet-header {
    font-size: 24px;
    padding: 16px;
    color: #2c3e50;
    letter-spacing: 1px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  }

  /* Full-page loader overlay */
  .full-page-loader-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.85);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    backdrop-filter: blur(4px);
  }

  .loader-content {
    text-align: center;
  }

  @media (max-width: 960px) {
    .calendar-container {
      padding: 10px;
    }

    .header-day,
    .service-name {
      min-width: 120px;
      font-size: 13px;
      padding: 8px 10px;
    }

    .header-date {
      min-width: 80px;
    }
  }

  @media (max-width: 600px) {
    .calendar-controls {
      padding: 10px;
    }

    .date-picker-input,
    .neon-btn {
      margin-top: 0;
      margin-bottom: 10px;
    }

    .service-name {
      min-width: 100px;
      max-width: 100px;
      font-size: 12px;
      padding: 8px 6px;
    }

    .component-name {
      font-size: 11px;
    }
  }
</style>
